import moment from 'moment';

const parseDates = (startDate, endDate) => {
  const start = moment(startDate, 'DD/MM/YYYY').isValid()
    ? moment(startDate, 'DD/MM/YYYY')
    : moment(new Date(startDate));
  const end = moment(endDate, 'DD/MM/YYYY').isValid() ? moment(endDate, 'DD/MM/YYYY') : moment(new Date(endDate));
  return [start, end];
};

export const handleDateDiff = (startDate, endDate) => {
  const [parsedStart, parsedEnd] = parseDates(startDate, endDate);
  const diff = moment.duration(parsedEnd.diff(parsedStart));

  const years = diff.years();
  const months = diff.months();
  const days = diff.days();

  const yearsText = years ? `${years} años, ` : '';
  const monthsText = months ? `${months} meses` : '';
  const daysText = days ? ` y ${days} días` : '';

  return `${yearsText}${monthsText}${daysText}`.trim();
};

export const resultFetchData = (response, type) => {
  const result = response.data.data;
  return result.map(element => ({
    ...element,
    label: `${type ? `${element.code} - ` : ''} ${element.name}`,
    value: element.id
  }));
};

export const chileanFormat = amount => {
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

export const attachValuesFromPayroll = (setFieldValue, data) => {
  const { payroll, employeeData } = data;
  if (payroll?.id) {
    setFieldValue('payrollId', payroll.id);
  }

  setFieldValue('employee[contractBalances]', employeeData?.vacationData[0]?.assets || []);
  setFieldValue('proportionalVacationDays', employeeData?.vacationData[0]?.proportionalVacation || 0);
  setFieldValue('legalVacationDays', employeeData?.vacationData[0]?.legalVacation || 0);
  setFieldValue('aditionalVacationDays', employeeData?.vacationData[0]?.additionalVacation || 0);
  setFieldValue('progressiveVacationDays', employeeData?.vacationData[0]?.progressiveVacation || 0);
  setFieldValue('nonWorkingDays', employeeData?.vacationData[0]?.nonWorkingDays || 0);
  setFieldValue('ufValue', employeeData.ufValue || 0);
  setFieldValue('max90Uf', employeeData.max90Uf || 0);
  setFieldValue('parsedUfValue', chileanFormat(employeeData.ufValue || 0));
  setFieldValue('parsed90UfValue', chileanFormat(employeeData.max90Uf || 0));
};

export const prepareBalancesToSave = values => {
  const {
    id,
    employee,
    issueDate,
    ufValue,
    max90Uf,
    simulation,
    variableIncome,
    noticeMonth,
    terminationReasonObject,
    justificationTerminationReason,
    payrollId,
    legalVacationDays,
    aditionalVacationDays,
    proportionalVacationDays,
    progressiveVacationDays,
    nonWorkingDays,
    totalVacationDays,
    endDate,
    paymentDate,
    noticeDate
  } = values;

  return {
    id,
    employee,
    issueDate,
    endDate,
    ufValue,
    max90Uf,
    simulation,
    variableIncome,
    noticeMonth,
    terminationReason: terminationReasonObject,
    justificationTerminationReason,
    payrollId,
    legalVacationDays,
    aditionalVacationDays,
    proportionalVacationDays,
    progressiveVacationDays,
    nonWorkingDays,
    totalVacationDays,
    paymentDate,
    noticeDate
  };
};

export const clearBalances = (props = [], setFieldValue) => {
  const balanceProps = ['variableAssets', 'taxableAssets', 'notTaxableAssets'];
  props.forEach(element => {
    balanceProps.forEach(balanceProp => {
      setFieldValue(`${element}[${balanceProp}]`, []);
    });
  });
};

export const prepareSettlementGroupToSave = values => {
  return { ...values };
};
